module.exports = __webpack_public_path__ + "static/media/as8tj93.44884a06.png";